import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "a277daa6-8dba-4c30-90fb-8cb9482db95c",
    authority: "https://login.microsoftonline.com/85c3e0e9-2cac-4681-957d-7990f8e0b4a0",
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest: PopupRequest = {
  scopes: [
    "User.Read",
    "profile",
    "openid",
    "email"
  ]
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};